import React from 'react';
import "./RodapePaginaSuspensa.css";
export default function RodapePaginaSuspensa() {
    return (
        <div className="conteudo rodape-pagina-suspensa">
            <p>Copyright © 2025 Construmarcas - Todos os direitos reservados</p>            
        </div>
    )
}